import React, { useState } from 'react';
import { sendContract } from './api';

const SendContract = () => {
	const [email, setEmail] = useState('');
	const [name, setName] = useState('');
	const [document, setDocument] = useState(null);
	const [message, setMessage] = useState('');

	const handleFileUpload = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onloadend = () => setDocument(reader.result);
		reader.readAsDataURL(file);
	};

	const handleSubmit = async () => {
		try {
			const response = await sendContract({
				email,
				name,
				document: document.split(',')[1], // Remove metadata from base64
			});
			setMessage(`Envelope sent! ID: ${response.data.envelopeId}`);
		} catch (error) {
			console.error(error);
			setMessage('Error sending contract');
		}
	};

	return (
		<div>
			<h1>Send a Contract</h1>
			<input
				type="email"
				placeholder="Recipient Email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
			/>
			<input
				type="text"
				placeholder="Recipient Name"
				value={name}
				onChange={(e) => setName(e.target.value)}
			/>
			<input type="file" onChange={handleFileUpload} />
			<button onClick={handleSubmit}>Send</button>
			{message && <p>{message}</p>}
		</div>
	);
};

export default SendContract;
